import React from 'react'
import styled from 'styled-components'
import { TABLET, DESKTOP, MEDIUM } from '@streamr/streamr-layout/styled'
import eth from './assets/eth.png'
import eth2x from './assets/eth@2x.png'
import docs from './assets/docs.png'
import docs2x from './assets/docs@2x.png'
import uniswap from './assets/uniswap.png'
import uniswap2x from './assets/uniswap@2x.png'
import binance from './assets/binance.png'
import binance2x from './assets/binance@2x.png'
import matcha from './assets/matcha.png'
import matcha2x from './assets/matcha@2x.png'
import metamask from './assets/metamask.png'
import metamask2x from './assets/metamask@2x.png'
import argent from './assets/argent.png'
import argent2x from './assets/argent@2x.png'
import rainbow from './assets/rainbow.png'
import rainbow2x from './assets/rainbow@2x.png'
import ledger from './assets/ledger.png'
import ledger2x from './assets/ledger@2x.png'
import frame from './assets/frame.png'
import frame2x from './assets/frame@2x.png'
import gnosis from './assets/gnosis.png'
import gnosis2x from './assets/gnosis@2x.png'

const assets = {
    broker: [eth, eth2x],
    sponsor: [eth, eth2x],
    delegator: [docs, docs2x],
    bounty: [eth, eth2x],
    publisher: [eth, eth2x],
    subscriber: [eth, eth2x],
    uniswap: [uniswap, uniswap2x],
    binance: [binance, binance2x],
    matcha: [matcha, matcha2x],
    metamask: [metamask, metamask2x],
    argent: [argent, argent2x],
    rainbow: [rainbow, rainbow2x],
    ledger: [ledger, ledger2x],
    frame: [frame, frame2x],
    gnosis: [gnosis, gnosis2x],
}

const UnstyledIcon = ({ name, ...props }) => {
    const [icon, icon2x] = assets[name]

    return (
        <div {...props}>
            <img src={icon} srcSet={`${icon2x} 2x`} alt="" />
        </div>
    )
}

const Icon = styled(UnstyledIcon)`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) translateY(-12px);

    img {
        width: 64px;
    }

    @media (min-width: ${TABLET}px) {
        top: 40px;
        left: 24px;
        transform: none;
    }

    @media (min-width: ${DESKTOP}px) {
        top: 70px;
        left: 52px;

        img {
            width: 110px;
        }
    }
`

const Arrow = () => (
    <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.682.79h7v7"
            stroke="#0C009A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            stroke="#0C009A"
            strokeWidth="1.5"
            strokeLinecap="round"
            d="M8.402 1.061L1.06 8.566"
        />
    </svg>
)

const Title = styled.div`
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: ${MEDIUM};

    svg {
        transition: 180ms transform ease-in-out;
        margin-left: 4px;
        margin-bottom: -2px;
    }

    @media (min-width: ${DESKTOP}px) {
        font-size: 1.25rem;
        line-height: 1.875rem;

        svg {
            margin-left: 8px;
            margin-bottom: 0;
        }
    }
`

const Description = styled.div`
    font-size: 0.75rem;
    line-height: 1.25rem;

    @media (min-width: ${DESKTOP}px) {
        font-size: 1.125rem;
        line-height: 1.875rem;
    }
`

const MoreInfo = styled.div``

const UnstyledGridItem = ({
    name,
    description,
    icon,
    url,
    className,
    ...props
}) => (
    <a {...props} className={className} href={url} target="_blank" rel="noreferrer noopener" $appear>
        {!!icon && !!assets[icon] && (
            <Icon name={icon} />
        )}
        <MoreInfo>
            <Title>
                {name}
                <Arrow />
            </Title>
            <Description>
                {description}
            </Description>
        </MoreInfo>
    </a>
)

const GridItem = styled(UnstyledGridItem)`
    width: 100%;
    background-color: #FAFAFA;
    border-radius: 8px;
    min-height: 144px;
    position: relative;
    transition: 300ms background-color ease-in-out;

    :hover {
        background-color: #F5F5F5;
    }

    :active,
    :focus {
        background-color: #EFEFEF;
    }

    :hover,
    :active,
    :focus {
        ${Title} {
            svg {
                transform: translate(2px, -2px);
            }
        }
    }

    ${MoreInfo} {
        position: absolute;
        bottom: 16px;
        left: 0;
        width: 100%;
        text-align: center;
        color: #0C009A;

        ${Description} {
            display: none;
        }
    }

    @media (min-width: ${TABLET}px) {
        min-height: 216px;

        ${MoreInfo} {
            bottom: 24px;
            left: 24px;
            right: 24px;
            width: auto;
            text-align: left;

            ${Description} {
                display: block;
            }
        }
    }

    @media (min-width: ${DESKTOP}px) {
        min-height: 360px;

        ${MoreInfo} {
            bottom: 40px;
            left: 52px;
            right: 52px;
        }
    }
`

const GridInner = styled.div`
    display: grid;
    grid-template-columns: 144px 144px;
    grid-row-gap: 1.5rem;
    grid-column-gap: 1.5rem;

    @media (min-width: ${TABLET}px) {
        grid-template-columns: 216px 216px 216px;
        grid-column-gap: 1.75rem;
        grid-row-gap: 1.75rem;
    }

    @media (min-width: ${DESKTOP}px) {
        grid-template-columns: 360px 360px 360px;
        grid-column-gap: 2.25rem;
        grid-row-gap: 2.25rem;
    }
`

const UnstyledIconGrid = ({ children, ...props }) => (
    <div {...props}>
        <GridInner>
            {children}
        </GridInner>
    </div>
)

const IconGrid = styled(UnstyledIconGrid)`
    display: flex;
    justify-content: center;
`

export default Object.assign(IconGrid, {
    GridItem,
})
